import { useState, useEffect, Fragment } from "@wordpress/element";
import { Listbox, RadioGroup, Transition } from "@headlessui/react";
import apiFetch from "@wordpress/api-fetch";
import { ChevronUpDownIcon } from "@heroicons/react/20/solid";

export default function UseCaseSidebar() {
	const [categories, setCategories] = useState([]);
	const [tags, setTags] = useState([]);

	// fetch the cats
	useEffect(() => {
		apiFetch({ path: "/wp/v2/use_case_feature" }).then((data) => {
			setCategories(data);
		});
	}, []);

	// fetch the tags
	useEffect(() => {
		apiFetch({ path: "/wp/v2/use_case_tag" }).then((data) => {
			setTags(data);
		});
	}, []);

	function handleCatChange(obj) {
		window.location = window.location.protocol + "//" + window.location.host + "/use-cases/?cat=" + obj.id;
	}

    function handleTagChange(obj){
        window.location = window.location.protocol + "//" + window.location.host + "/use-cases/?tags=" + obj.id;
    }

	return (
		<>
			{categories && (
				<RadioGroup onChange={handleCatChange} className="categories">
					<RadioGroup.Label className="categories-title">
						Features
					</RadioGroup.Label>
					{categories.map((category, j) => (
						<RadioGroup.Option
							key={j}
							value={category}
							className={`categories-item`}
						>
							
                        <div>
                            <RadioGroup.Label>{category.name}</RadioGroup.Label>
                        </div>
						</RadioGroup.Option>
					))}
				</RadioGroup>
			)}
			{tags && (
				<div className="tags-selector">
					<label
						for="headlessui-listbox-button-:r2:"
						className="functions-title"
					>
						Functions
					</label>
					<Listbox onChange={handleTagChange}>
						<Listbox.Button>
							 All Functions:
							<ChevronUpDownIcon className="button-icon" />
						</Listbox.Button>
						<Transition
							as={Fragment}
							leave="transition ease-in duration-100"
							leaveFrom="opacity-100"
							leaveTo="opacity-0"
						>
							<Listbox.Options>
								{tags.map((tag, i) => (
									<Listbox.Option key={i} value={tag}>
										<div className="tags-item">{tag.name}</div>
									</Listbox.Option>
								))}
							</Listbox.Options>
						</Transition>
					</Listbox>
				</div>
			)}
		</>
	);
}
